import { motion } from "framer-motion";

export function SectionEyebrow({ children, testId }) {
  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <span className="h-px w-8 bg-[hsl(var(--accent))]" />
      <span className="eyebrow">{children}</span>
    </div>
  );
}

export function Reveal({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function PageHero({ eyebrow, title, lead, testId }) {
  return (
    <section data-testid={testId} className="container-x pt-16 md:pt-24 pb-12 md:pb-16">
      <SectionEyebrow>{eyebrow}</SectionEyebrow>
      <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight font-medium text-balance max-w-4xl">
        {title}
      </h1>
      {lead && <p className="mt-6 max-w-2xl text-base md:text-lg text-muted-foreground leading-relaxed">{lead}</p>}
    </section>
  );
}
